import React, { createContext, useContext, useState } from 'react';
import { TicketsContextProviderProps, TicketsContextType } from './interface';

export const TicketsContext = createContext({} as TicketsContextType);

export function TicketsContextProvider(props: TicketsContextProviderProps) {
  const { children } = props;

  const [refreshTable, setRefreshTable] = useState<boolean>(false);

  const reloadTableTicket = () => {
    setRefreshTable(!refreshTable);
  };

  return (
    <TicketsContext.Provider value={{
      refreshTable,
      setRefreshTable,
      reloadTableTicket
    }}>
      {children}
    </TicketsContext.Provider>
  );
}

export const useTicketsContext = () => {
  return useContext(TicketsContext);
};